import {CustomPayoutSubId} from './custom-payout-sub-id';
import {CustomPayoutOffer} from './custom-payout-offer';
import {AbstractModel} from './abstract-model';
import {User} from './user';
import {Partner} from './partner/partner';
import {Goal} from './goal';
import {GoalType} from './goal-type';
import {Currency} from './currency';

export class CustomPayout extends AbstractModel {
  id: number | null = null;
  user: User | null = null;
  partner: Partner | null = null;
  startingAt: Date | null = null;
  name: string = '';
  currency: Currency | null = null;
  payoutAmount: number = 0;
  payoutPercent: number = 0;
  enabled: boolean = true;
  position: number = 0;
  goal: Goal | null = null;
  goalType: GoalType | null = null;
  subIds: CustomPayoutSubId[] = [];
  offers: CustomPayoutOffer[] = [];

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.user) {
      this.user = new User().deserialize(input.user);
    }

    if (input.partner) {
      this.partner = new Partner().deserialize(input.partner);
    }

    if (input.goal) {
      this.goal = new Goal().deserialize(input.goal);
    }

    if (input.goalType) {
      this.goalType = new GoalType().deserialize(input.goalType);
    }

    if (input.subIds) {
      this.subIds = input.subIds.map((subId: any) => new CustomPayoutSubId().deserialize(subId));
    }

    if (input.offers) {
      this.offers = input.offers.map((offer: any) => new CustomPayoutOffer().deserialize(offer));
    }

    if (input.currency) {
      this.currency = new Currency().deserialize(input.currency);
    }

    return this;
  }

  getStartingDate(): string {
    if (!this.startingAt) {
      return '';
    }

    return this.startingAt?.getUTCFullYear() + '-' +
      String(this.startingAt?.getUTCMonth() + 1).padStart(2, '0') + '-' +
      String(this.startingAt?.getUTCDate()).padStart(2, '0');
  }

  override toString(): string {
    return this.name ?? '';
  }
}
